import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { useSnackbar } from '../contexts/SnackbarProvider';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';

import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import RelatedMenu from '../components/RelatedMenu';
import { AddBusiness } from '@mui/icons-material';
import { Paper, Button, Link, Typography, Chip } from "@mui/material";
import SupplierModal from '../components/SupplierModal';
const SuppliersPage = () => {

    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const {
        dataset,
        error,
        currentPage,
        totalPages,
        searchQuery,
        handleSearchChange,
        handleSearchSubmit,
        handleClearSearch,
        handlePageChange,
        refetch
    } = useDataFetch('/supplier', {
        supplier_code: '',
        supplier_name: ''
    });

    const handleRowClick = (item) => {
        navigate(`/suppliers/${item.supplier_id}`);
    };
    const handleCreated = () => {
        setOpen(false);
        refetch();
    };

    const fieldsToInclude = ['supplier_code', 'supplier_name'];
    const searchItems = getFields(searchFields, fieldsToInclude);

    const columns = [
        {
            label: '仕入先コード',
            accessor: 'supplier_code',
            render: (item) => (
                <Link onClick={() => handleRowClick(item)}>{item.supplier_code}</Link>
            ),
            width: '150px',
        },
        {
            label: '企業名',
            accessor: 'supplier_name',
            render: (item) => (
                <Typography >{item.supplier_name}</Typography>
            ),
            width: '300px',
        },
        {
            label: '電話番号',
            accessor: 'phone',
            width: '160px',
        },
        {
            label: 'メールアドレス',
            accessor: 'email',
            render: (item) => (
                <Typography >{item.email}</Typography>
            ),
            width: '220px',
        },
        {
            label: "ステータス",
            width: "80px",
            render: (row) => {
                const map = {
                    active: { label: "有効", color: "success" },
                    pending: { label: "保留", color: "warning" },
                    invalid: { label: "無効", color: "default" }
                };
                const s = map[row.status];
                return s ? (
                    <Chip label={s.label} size="small" color={s.color} />
                ) : null;
            }
        },
        {
            label: '',
            render: (item) => (
                <Button
                    size="small"
                    variant="outlined"
                    onClick={() => handleRowClick(item)}
                >
                    詳細
                </Button>
            ),
            width: '80px',
        },
    ];

    const links = [
    ];

    if (error) return <GlobalError errorMessage={error} />;

    return (
        <>
            <Typography variant="h1" component="h1">
                仕入れ先一覧
            </Typography>

            <div className="grid2-2_1">

                <SearchForm
                    searchQuery={searchQuery}
                    searchFields={searchItems}
                    handleSearchChange={handleSearchChange}
                    handleSearchSubmit={handleSearchSubmit}
                    handleClearSearch={handleClearSearch}
                />

                <RelatedMenu links={links} >
                    <Button
                        variant="related-menu"
                        startIcon={<AddBusiness />}
                        onClick={() => setOpen(true)}
                    >
                        仕入れ先追加
                    </Button>

                </RelatedMenu>

            </div>

            <Paper variant="section">

                <TableView
                    dataset={dataset}
                    columns={columns}
                    keyColumn="supplier_id"
                />

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />

            </Paper>
            <SupplierModal
                open={open}
                onClose={() => setOpen(false)}
                onSaved={handleCreated}
            />
        </>
    );
};

export default SuppliersPage;